import React, { useState } from 'react';
import { Tabs, Card, Typography, Space, Badge } from 'antd';
import {
  BankOutlined,
  UsergroupAddOutlined,
  SwapOutlined,
} from '@ant-design/icons';
import { useCompany } from '../../../contexts/CompanyContext';
import {
  useTreasuryAccounts,
  usePartnerBalances,
} from '../../../hooks/useAccounting';
import TreasuryAccountsTab from './TreasuryAccountsTab';
import PartnerBalancesTab from './PartnerBalancesTab';
import TreasuryMovementsTab from './TreasuryMovementsTab';

const { Title, Text } = Typography;

export const TreasuryView: React.FC = () => {
  const { company } = useCompany();
  const [activeTab, setActiveTab] = useState<string>('accounts');

  const { accounts } = useTreasuryAccounts({
    company_id: company.current?.id,
    company_uid: company.current?.uid || undefined,
  });

  const { partnerBalances } = usePartnerBalances({
    company_id: company.current?.id,
    company_uid: company.current?.uid || undefined,
  });

  const tabItems = [
    {
      key: 'accounts',
      label: (
        <Space size={6}>
          <BankOutlined />
          <span>Cuentas de Tesorería</span>
          {accounts.length > 0 && (
            <Badge count={accounts.length} overflowCount={99} style={{ backgroundColor: '#1890ff' }} />
          )}
        </Space>
      ),
      children: <TreasuryAccountsTab />,
    },
    {
      key: 'partners',
      label: (
        <Space size={6}>
          <UsergroupAddOutlined />
          <span>Cuenta Corriente de Socios</span>
          {partnerBalances.length > 0 && (
            <Badge
              count={partnerBalances.length}
              overflowCount={99}
              style={{ backgroundColor: '#13c2c2' }}
            />
          )}
        </Space>
      ),
      children: <PartnerBalancesTab />,
    },
    {
      key: 'movements',
      label: (
        <Space size={6}>
          <SwapOutlined />
          <span>Movimientos y Transferencias</span>
        </Space>
      ),
      children: <TreasuryMovementsTab />,
    },
  ];

  return (
    <div style={{ padding: '24px 24px', background: '#f5f5f5', minHeight: '100vh' }}>
      <div style={{ marginBottom: 16 }}>
        <Title level={4} style={{ margin: 0, color: '#1f1f1f' }}>
          Tesorería, Cuentas Bancarias y Socios
        </Title>
        <Text type="secondary" style={{ fontSize: 13 }}>
          Administración centralizada de cuentas de bancos, cajas, tarjetas, transferencias internas y cuenta corriente con socios / accionistas (Deudas 2355 y Cuentas por Cobrar 1325).
        </Text>
      </div>

      <Card variant="borderless" style={{ borderRadius: 8, boxShadow: '0 1px 3px rgba(0,0,0,0.05)' }}>
        <Tabs
          activeKey={activeTab}
          onChange={(k) => setActiveTab(k)}
          items={tabItems}
          type="line"
          size="middle"
        />
      </Card>
    </div>
  );
};

export default TreasuryView;